import { render, staticRenderFns } from "./GlobalSelectionDialog.vue?vue&type=template&id=1d3e5a84&scoped=true"
import script from "./GlobalSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./GlobalSelectionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e5a84",
  null
  
)

export default component.exports